import * as msg from '../../../../../node_modules/console-tags.js/src/console-tags.js'
import { HomeHeader, homeSlider, propertieSlider, countrySlider} from '../../components/carousels'
import {indexMap} from '../../components/maps'
import {homeParallax} from '../../components/parallax'
import { smoothScroll} from '../../components/nav'
import filterSubMarket  from '../../components/filter'

const init = () => {
  HomeHeader()
  homeSlider()
  propertieSlider()
  indexMap()
  countrySlider()
  homeParallax()
  smoothScroll()
  filterSubMarket()

}

export default init
